// Bug C / Opción 3: una capacitación completada después de su fecha límite se marca
// como "Tarde". La inscripción sigue "Completado" (se hizo); el chip solo señala la
// tardanza. Fuente de verdad = completed_at > due_date, idéntico al API (curso sin
// fecha límite nunca es tarde). Predicado puro, reusable.
export function isCompletedLate(enrollment: {
  status: string;
  completed_at: string | null;
  due_date: string | null;
}): boolean {
  if (enrollment.status !== 'completed') return false;
  if (!enrollment.completed_at || !enrollment.due_date) return false;
  return new Date(enrollment.completed_at).getTime() > new Date(enrollment.due_date).getTime();
}
